import { render } from "./cell_report_tag.vue?vue&type=template&id=4c8eeb9b"
import script from "./cell_report_tag.vue?vue&type=script&lang=ts"
export * from "./cell_report_tag.vue?vue&type=script&lang=ts"

import "./cell_report_tag.vue?vue&type=style&index=0&id=4c8eeb9b&lang=less"
script.render = render

export default script